import styled from "styled-components";

export const SocialMentionsContainer = styled.div``;